import { render, staticRenderFns } from "./RelationInfo.vue?vue&type=template&id=179974e6"
import script from "./RelationInfo.vue?vue&type=script&lang=js"
export * from "./RelationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports